import React from "react";
import { cn } from "@/lib/utils";

export const Skeleton = ({ className, ...rest }) => (
  <div
    className={cn(
      "jea-shimmer rounded-md bg-bg-tertiary",
      className
    )}
    {...rest}
  />
);

export default Skeleton;
